import { render, staticRenderFns } from "./nursing_care_facility.vue?vue&type=template&id=91470844&scoped=true&"
import script from "./nursing_care_facility.vue?vue&type=script&lang=js&"
export * from "./nursing_care_facility.vue?vue&type=script&lang=js&"
import style0 from "./nursing_care_facility.vue?vue&type=style&index=0&id=91470844&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91470844",
  null
  
)

export default component.exports